module.exports = __webpack_public_path__ + "img/g3.d5fad727.png";